export const RANGE_SP = {
  init: function (variables) {
    const mq = window.matchMedia('(max-width: 768px)')
    mq.addListener(() => this.check(mq, variables))
    this.check(mq, variables)
  },
  check: function (mq, variables) {
    variables.range_sp = mq.matches
  },
}
